export enum ONBOARDING_STEP {
    WELCOME = 'WELCOME',
    WHO_IS_USING = 'WHO_IS_USING',
    TEAM_INTRO = 'TEAM_INTRO',
    SHARE_INFO = 'SHARE_INFO',
    USAGE = 'USAGE',
    FINISH = 'FINISH'
}

export interface OnboardingData {
    completed?: boolean;
    items?: any;
}